import { formatNumberToCurrency } from './currency'

export function abbreviateNumber(value: number, isCurrency: boolean = true) {
  const units = [
    { limit: 1e12, suffix: 'T' }, // Trillions
    { limit: 1e9, suffix: 'B' }, // Billions
    { limit: 1e6, suffix: 'M' }, // Millions
  ]

  for (const unit of units) {
    if (value >= unit.limit) {
      if (isCurrency) {
        return `R$ ${(value / unit.limit).toFixed(2)}${unit.suffix}`
      }

      return `${(value / unit.limit).toFixed(0)}${unit.suffix}`
    }
  }

  if (isCurrency) {
    return formatNumberToCurrency(Number(`${value}`))
  }

  return value
}
